import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Card } from 'semantic-ui-react';

const hintTextStyle = { float: 'left', marginTop: 1 };
const iconStyle = { float: 'right', marginTop: 1 };

const LoadingMoreIndicator = ({
  shownEventsCount,
  isLoadingMore,
  canLoadMore,
}) => (
  <Card.Content extra>
    <span
      style={hintTextStyle}
    >
        showing { canLoadMore ? `last ${shownEventsCount}` : 'all' } events
    </span>
    <span
      style={iconStyle}
    >
      {
        isLoadingMore && <Icon name="circle notched" loading />
      }
    </span>
  </Card.Content>
);

LoadingMoreIndicator.propTypes = {
  shownEventsCount: PropTypes.number.isRequired,
  isLoadingMore: PropTypes.bool.isRequired,
  canLoadMore: PropTypes.bool.isRequired,
};

export default LoadingMoreIndicator;



/** WEBPACK FOOTER **
 ** ./src/containers/event-feed/other-elements/loading-more-indicator.js
 **/